import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { Btn, Card, Input, Toggle } from "../dash/Shell";

export default function AdminServices() {
  const [rows, setRows] = useState([]);
  const [prices, setPrices] = useState({});

  const load = () => api.get("/services?all=true").then(({ data }) => { setRows(data); setPrices(Object.fromEntries(data.map((s) => [s.id, s.price]))); });
  useEffect(() => { load().catch((e) => toast.error(errMsg(e))); }, []);

  const patch = async (id, body) => {
    try { await api.patch(`/admin/services/${id}`, body); await load(); toast.success("Updated"); } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <Card title="Services" sub="Turn a service OFF to hide it from online booking globally. Update starting prices here." testid="admin-services">
      <ul className="grid md:grid-cols-2 gap-3">
        {rows.map((s) => (
          <li key={s.id} data-testid={`admin-service-${s.id}`} className={`rounded-2xl border p-4 ${s.enabled ? "border-white/10" : "border-red-400/30 bg-red-400/5"}`}>
            <div className="flex items-center justify-between gap-3">
              <div>
                <p className="text-white font-medium">{s.name.en}</p>
                <p className="text-slate-400 text-xs">{s.name.te}</p>
              </div>
              <Toggle testid={`admin-service-toggle-${s.id}`} on={s.enabled} onChange={(v) => patch(s.id, { enabled: v })} />
            </div>
            <div className="flex gap-2 mt-4">
              <Input data-testid={`admin-service-price-${s.id}`} type="number" min="0" value={prices[s.id] ?? ""} onChange={(e) => setPrices((p) => ({ ...p, [s.id]: e.target.value }))} />
              <Btn variant="ghost" data-testid={`admin-service-save-${s.id}`} onClick={() => patch(s.id, { price: Number(prices[s.id]) })}>Save ₹</Btn>
            </div>
          </li>
        ))}
      </ul>
    </Card>
  );
}
